module.exports = __webpack_public_path__ + "img/brand-mercedes-benz.ce39c810.png";